import request from '@/utils/request';

export function getAiSettings() {
  return request({
    url: '/admin/ai-settings',
    method: 'get',
  });
}

export function updateAiSettings(data) {
  return request({
    url: '/admin/ai-settings',
    method: 'put',
    data,
  });
}

export function updateTaskAiSettings(task, data) {
  return request({
    url: `/admin/ai-settings/task/${task}`,
    method: 'put',
    data,
  });
}

export function testAiConnection(task) {
  return request({
    url: '/admin/ai-settings/test',
    method: 'post',
    data: task ? { task } : {},
    timeout: 35000, // AI test can take up to 30s
  });
}
